<template>
    <b-card class="custom-card-products pb-0" :class="{ 'bg-card-pruduct-active': product.type_status === 'active' }">
        <div class="d-flex align-items-center mt-1 container-header-products">
            <div class="mr-2">
              <img-loader :src="product.logo" :refId="product.title" :alt="`Logo ${product.title}`" classImg="custom-logo-products"/>
            </div>
            <h2 class="m-0 text-primary"><strong>{{ product.title }}</strong></h2>
            <b-badge
                :variant="badgeProduct.variant"
                pill
                class="custom-badge-products"
                :class="badgeProduct.class"
            >{{ badgeProduct.text }}</b-badge>
        </div>
        <hr>
        <div>
            <p class="m-0 custom-description-card">{{ product.description }}</p>
        </div>
        <div
          class="d-flex justify-content-end"
        >
            <b-button
                variant="outline-warning"
                class="btn-custom-product mt-50 mb-50"
                :class="{ 'hidden-button-product': handleButtonAction }"
                :disabled="loadingBtn"
                @click="handleAction()"
            >
                <strong>{{ textActionButton }}</strong>
            </b-button>
            <div
              v-if="handleButtonRedirect"
              class="d-flex align-items-center">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.98539 21.1696V8.19531H2.00269V21.1696H4.98539Z" stroke="#1B4284" stroke-width="2.204" stroke-linejoin="round"/>
                  <path d="M4.98584 8.19398C8.52681 4.34887 10.5789 2.14323 11.1421 1.5759C11.9872 0.724901 12.9417 1.08229 12.9417 3.21243C12.9417 5.34258 10.3144 6.57101 10.3144 8.19398C10.3125 8.20342 13.673 8.20401 20.3945 8.19575C20.5904 8.19544 20.7845 8.24094 20.9656 8.32964C21.1467 8.41834 21.3113 8.5485 21.45 8.7127C21.5887 8.87689 21.6987 9.07189 21.7738 9.28656C21.849 9.50123 21.8877 9.73136 21.8878 9.9638V9.96557C21.8878 10.4354 21.7305 10.886 21.4504 11.2183C21.1704 11.5505 20.7905 11.7372 20.3945 11.7372H16.4126C15.8121 16.4392 15.4805 18.9951 15.4183 19.4062C15.3249 20.0218 14.8293 21.1683 13.403 21.1683H4.98584V8.19398Z" stroke="#1B4284" stroke-width="2.204" stroke-linejoin="round"/>
              </svg>
              <a
                  @click="goProduct()"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="link"
                  class="p-0 m-0"
              >
                  <span class="ml-50 link-color text-primary"><strong>{{ textActiveButton }}</strong></span>
              </a>
            </div>
        </div>
    </b-card>
</template>
<script>
export default {
  props: ['product', 'userSession'],
  data () {
    return {
      badgeProduct: {
        variant: 'outline-primary',
        text: 'Función',
        class: 'custom-badge-products-function'
      },
      textActionButton: 'Solicitar',
      textActiveButton: 'Ver detalles',
      loadingBtn: false
    }
  },
  computed: {
    handleButtonAction () {
      if (!this.product || !this.userSession) return false
      const isAdmin = this.userSession.role === 'admin'
      const isActive = this.product.type_status === 'active'
      const isAvailable = this.product.type_status === 'available'
      if (isAdmin) {
        return isActive
      }
      return !isAvailable
    },
    handleButtonRedirect () {
      if (!this.product || !this.userSession) return false
      const isAdmin = this.userSession.role === 'admin'
      const isActive = this.product.type_status === 'active'
      const isOnlyAdmin = this.product.only_admin
      if (this.product.id === 1) return false
      if (isOnlyAdmin && !isAdmin) return false
      if (!isActive) return false
      return true
    }
  },
  watch: {
    product () {
      this.setCard()
    }
  },
  mounted () {
    this.setCard()
  },
  methods: {
    setCard () {
      this.textActionButton = this.getTextActionButton()
      this.badgeProduct = this.getTextActionButton()
      this.textActiveButton = this.getTextActiveButton()
    },
    getTextActionButton () {
      if (this.product.id === 1 && this.product.type_status === 'available') return 'Ver más'
      const actionTexts = {
        requested: 'Activar',
        available: 'Solicitar'
      }
      return actionTexts[this.product.type_status] || 'Solicitar'
    },
    getBadgeProduct () {
      const isFunction = this.product.type === 'function'
      return {
        variant: `outline-${isFunction ? 'primary' : 'warning'}`,
        text: isFunction ? 'Función' : 'App',
        class: `custom-badge-products-${isFunction ? 'function' : 'app'}`
      }
    },
    getTextActiveButton () {
      return this.product.type === 'function' ? 'Ver detalles' : 'Ir al Login'
    },
    executeAction(value, actions) {
      if (actions[value]) {
        actions[value]()
      }
    },
    handleAction () {
      this.loadingBtn = true
      const actions = {
        '1_available': () => this.$emit('actionButton', 'more_info', this.product),
        'available': () => this.$emit('actionButton', 'request', this.product),
        'requested': () => this.$emit('actionButton', 'active', this.product)
      }
      const actionKey = this.product.id === 1 && this.product.type_status === 'available' ? `1_${this.product.type_status}` : this.product.type_status
      this.executeAction(actionKey, actions)
    },
    goProduct () {
      const actions = {
        app: () => window.open(this.product.url, '_blank'),
        function: () => this.redirectToProduct()
      }
      this.executeAction(this.product.type, actions)
    },
    redirectToProduct () {
      const actions = {
        2: () => this.m_openWinBlank('/envia-flash/create') /*Nueva pestaña*/,
        3: () => this.m_openWinBlank('/marketcenter') /*Nueva pestaña*/,
        4: () => this.$emit('redirectCompany')
      }
      this.executeAction(this.product.id, actions)
    }
  }
}
</script>
<style>
.card-body .custom-card-products {
  box-shadow: 0px 1px 3px 1px #00000026 !important;
  padding: 2rem;
  border-radius: 16px;
  max-width: 100%;
  width: 446px;
  height: auto;
}
.bg-card-pruduct-active {
  background: #0443890D;
}
.custom-card-products hr {
  width: 100%;
}
.custom-card-products .card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.btn-custom-product {
  padding: 0.9rem 3rem;
}
.custom-badge-products {
  position: absolute;
  top: 15px;
  right: 40px;
  font-size: 9px;
  background-color: #ffffff00 !important;
}
.custom-badge-products-app {
  padding: 0.5rem 1rem;
}
.custom-badge-products-function {
  padding: 0.5rem 0.2rem;
}
.hidden-button-product {
  opacity: 0;
  visibility: hidden;
}
.custom-logo-products {
  width: initial !important;
}
@media (max-width: 426px) {
  .container-header-products {
    flex-wrap: wrap;
  }
  .container-header-products h2 {
    font-size: 1rem
  }
}
</style>